import React from "react";
import { Avatar, Typography, Box, Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ListView = ({
  categories,
  page,
  handleBreedGoNow,
  handleSubBreedGoNow,
  serviceId,
  search,
}) => {
  const navigate = useNavigate();

  const handleClick = (data) => {
    if (page === "Classes") {
      if (data.active) navigate("/classes/" + data.id + "/breeds");
    } else if (page === "Services") {
      navigate("/services/" + data.id);
    } else if (page === "breeds") {
      handleBreedGoNow(data.id);
    } else if (page === "subbreeds") {
      handleSubBreedGoNow(data.id);
    } else if (page === "genetics") {
      navigate(`/listings/genetics/${data.id}`);
    } else if (page === "subservice") {
      navigate(`/services/${serviceId}/subService/${data.id}/listings`);
    }
  };

  const filtered = categories?.filter((item) =>
    !search || item.name.toLowerCase().includes(search.toLowerCase())
  );

  if (!filtered || filtered.length === 0) {
    return (
      <Typography textAlign="center" sx={{ color: "#555", py: 6 }}>
        No results found.
      </Typography>
    );
  }

  return (
    <Box sx={{ maxWidth: 640, mx: "auto", display: "flex", flexDirection: "column", gap: 1 }}>
      {filtered.map((data) => (
        <Box
          key={data.id || data.name}
          onClick={() => handleClick(data)}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            px: 2,
            py: 1.5,
            backgroundColor: "#1a1a1a",
            border: "1px solid #2a2a2a",
            borderRadius: "12px",
            cursor: data.active !== false ? "pointer" : "default",
            transition: "all 0.25s ease",
            "&:hover": data.active !== false
              ? {
                  borderColor: "#FFC001",
                  backgroundColor: "#222",
                  transform: "translateX(4px)",
                }
              : {},
          }}
        >
          <Avatar
            src={data.image}
            alt={data.name}
            sx={{
              width: 44,
              height: 44,
              border: "1px solid #333",
              flexShrink: 0,
            }}
          />
          <Typography
            sx={{
              color: "#fff",
              fontWeight: 600,
              fontSize: "15px",
              flex: 1,
            }}
          >
            {data.name}
          </Typography>
          {data.active === false && (
            <Chip
              label="Coming Soon"
              size="small"
              sx={{
                backgroundColor: "#FFC001",
                color: "#000",
                fontWeight: 700,
                fontSize: "11px",
                height: "22px",
                borderRadius: "6px",
              }}
            />
          )}
          {data.active !== false && (
            <Typography sx={{ color: "#FFC001", fontSize: "18px", lineHeight: 1 }}>
              →
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default ListView;
